import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import PersonAdd from '@material-ui/icons/PersonAdd'
import { createGroup, loadProfile } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import { ErrorMessage } from '../../../../../components/error-message'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 540px;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;

  &:hover {
    background: #EFEFEF;
  }

  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`

const AddGroup = (props) => {
  const { user, updateUser } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext)
  const [loading, updateLoading] = useState(false)
  const [name, updateName] = useState('')
  const [error, updateError] = useState('')

  const handleAdd = () => {
    if(name === '') {
      updateError('Please enter a name for the new group.')
    } else {
      const lowerName = name.toLowerCase()
      let duplicate = false
      for(let i = 0; i < user.groups.length; ++i) {
        if (user.groups[i].name.toLowerCase() === lowerName) {
          duplicate = true
          break
        }
      }
      if(duplicate) {
        updateError('An existing group already has that name.')
      } else {
        updateLoading(true)
        createGroup(user.id, name).then((res) => {
          loadProfile(user.id).then((res) => {
            if (res.data.profile.active === 1) {
              updateUser(res.data.profile)
            }
            updateLoading(false)
            updateError('')
            openSnackbar('Group successfully added.', false)
          })
        }).catch((err) => {
          console.log(err) 
          updateLoading(false)
          updateError('')
          openSnackbar('There was a problem adding this group.', true)
        })
      }
    }
  }

  return (
    <React.Fragment>
      <Container className={props.className}>
        <HeaderContainer>
          <Label>
            <PersonAdd /> Add a Group
          </Label>
        </HeaderContainer>
        <Input
          error={error !== ''}
          label="Name"
          value={name}
          onChange={updateName}
        />

        {error !== '' && 
          <ErrorMessage>
            {error}
          </ErrorMessage>
        }
        <ButtonContainer>
          <ClearButton
            label="Clear"
            onClick={() => { updateName(''); updateError('');}}
          />
          <AddButton 
            label="Add Group"
            isLoading={loading}
            onClick={handleAdd}
          />
        </ButtonContainer>
      </Container>
    </React.Fragment>
  )
}

export default AddGroup